<template>
  <div class="h-full overflow-auto" :class="$style['landing-background']">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "LandingBackground",
  setup() {},
});
</script>

<style lang="css" module>
.landing-background {
  background-color: #684945; /* average color from the sky of the bg */
  background-image: url("/images/bg-public.jpg");
  background-size: cover;
  background-position: center 0;
  background-repeat: no-repeat;
}
</style>
